import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import {PersistGate} from 'redux-persist/integration/react';
import 'regenerator-runtime';
import AuthFrameLogin from './components/AuthFrameLogin';
import Portal from './components/Portal';
import configureStore from './store/appStore';

const {persistor, store} = configureStore();

/**
 * Main Application
 *
 * @author OBJECT ECM
 */
class Application extends Component {
  /**
   * Construct a new instance.
   *
   * @param {*} props - The properties.
   */
  constructor(props) {
    super(props);
  }

  /**
   * Render.
   *
   * @return {string} - The rendered HTML code for the application.
   */
  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route path='/login'>
            <AuthFrameLogin />
          </Route>
          <Route>
            <Portal />
          </Route>
        </Switch>
      </BrowserRouter>
    );
  }
}

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Application />
    </PersistGate>
  </Provider>,
  document.getElementById('application')
);
